<template>
  <div style="padding:5px;">
    <v-text-field label="Search" v-model="searchTerm" @input="searchDebounce" outline>
      <template slot="append">
        <v-icon @click="search">search</v-icon>
      </template>
      <template slot="append-outer">
        <router-link :to="{name:'searchExisting'}">Old search</router-link>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "Searchbar",
  data() {
    return {
      searchTerm: null,
      timerId: null,
      delay: 1000
    };
  },
  methods: {
    searchDebounce() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.search();
      }, this.delay);
    },
    search() {
      if (this.searchTerm) {
        if (this.isInt(this.searchTerm)) {
          this.$router.push({
            name: "integer",
            params: {
              searchValue: this.searchTerm
            }
          });
        } else {
          this.$router.push({
            name: "general",
            params: {
              searchValue: this.searchTerm
            }
          });
        }
      }
    },
    isInt(value) {
      if (isNaN(value)) {
        return false;
      }
      var x = parseFloat(value);
      return (x | 0) === x;
    }
  }
};
</script>
